module.exports = __webpack_public_path__ + "why17.webp?a6ac80a18a09c82b8205c5df6034c731";